import http from 'plugins/axios';

export default {
  getCoinTypes() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getRecords(data) {
    return http.get({
      url: '/admin/record/search_record',
      data
    });
  },
  createRecord(data) {
    return http.get({
      url: 'admin/record/add',
      data
    });
  }
};
